import { css } from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
const StyledBaseCardMetaData = css`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 13px;
  font-weight: 500;
  color: ${({
  theme
}) => theme.base.black};
  background: ${({
  hasBodyBackground,
  theme
}) => hasBodyBackground ? theme.base.white : 'transparent'};
  z-index: 1;

  ${breakpoints.md} {
    color: ${({
  hasBodyBackground,
  theme
}) => hasBodyBackground ? theme.base.black : theme.base.white};
    padding: 0 0 25px 0;
    width: calc(100% - 40px);
  }
`;
export default StyledBaseCardMetaData;